import React from "react"

const SeminarStatus = ({ status }) => {
	const receptionNow = status.includes("参加受付中") ? <div className="reception">参加受付中</div> : ""
	const receptionClosing = status.includes("受付終了") ? <div className="reception closing">参加受付終了</div> : ""
	const receptionEnd = status.includes("開催終了") ? <div className="reception end">開催終了</div> : ""

	return (
		<>
    {receptionNow}
    {receptionClosing}
    {receptionEnd}
		</>
	)
}

export default SeminarStatus
